// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3lO0N","title":"Images45_title__3Oa6A","images":"Images45_images__l3Cf0"};